import { token } from '@atlaskit/tokens';
import ContentLink from '@databases/content-link/ContentLink';
import { type DatabaseFieldType, type RawDatabaseValue } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;
  width: 100%;

  > li + li {
    margin-top: ${token('space.075', '6px')};
  }
`;

const preventDefault = (e: React.MouseEvent | React.FocusEvent) => {
  // Prevent propagation to inline edit
  e.stopPropagation();
};

const PageLinkValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.PAGE_LINK>
> = ({ value, noFocus, showDisabledValue }) => {
  const displayableValues = value.filter(
    (
      v: RawDatabaseValue<DatabaseFieldType.PAGE_LINK>[0]
    ): v is {
      contentId: string;
      _id: string;
    } => 'contentId' in v
  );

  // TODO NCTD-2562 show error for blog posts

  return (
    <Container>
      {displayableValues.map((v) => (
        <li key={`${v._id}`}>
          <ContentLink
            contentId={v.contentId}
            noFocus={noFocus}
            onClick={preventDefault}
            onFocus={preventDefault}
            showDisabledValue={showDisabledValue}
          />
        </li>
      ))}
    </Container>
  );
};

export default PageLinkValueView;
